import {useAxios} from "@vueuse/integrations/useAxios";
import useAxiosInstance from "~/composables/api/utils/useAxiosInstance";
import {apiErrorHandler} from "~/utils/apiErrorHandler";

const automaticLogoutErrors = ['jwt_session_expired', 'jwt_session_invalid_signature', 'jwt_session_generic_error', 'customer_disabled']
export const useApi = () => ({
  async makeRequest(url, method = "get", data = null, additionalConfig = {}, useAuth = true) {
    const config = {method, data, ...additionalConfig};
    const instance = useAuth ? useAxiosInstance() : {immediate: true}
    const {data: response, error} = await useAxios(url, config, instance)

    if (error.value) {
      try {
        apiErrorHandler(error.value)
      } catch (serverError) {
        if (automaticLogoutErrors.includes(serverError.message) && process.client) {
          const router = useRouter()
          router.push("/logout").catch((e) => {
            console.error(e)
          })
        } else {
          throw serverError
        }
      }
    }
    return unref(response)
  }
})
